import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalMetricsHandoff } from '@/pages/workspaces/transactional/message/overview/metrics/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/metrics',
)({
  component: JourneysTransactionalMetricsHandoff,
});
